import type { EmailBodyContent } from '@lotta/shared/types-types';

export const transformBody = (input: string): EmailBodyContent => {
  const lines = input.split('\n');
  const nonEmptyLines = lines.filter((line) => line.trim() !== '');
  const copy =
    nonEmptyLines.length > 0
      ? nonEmptyLines.map((section) => ({ bodyCopy: section }))
      : [{ bodyCopy: '' }];

  return { copy };
};
